import { jsonInstance } from "./Api";

class DemoCallService {

  initiateCall(data) {
    return jsonInstance.post("/client-calls/start-call", data);
  }

  getPolicyDetails(data) {
    return jsonInstance.get(`/policy-details/${data.id}`);
  }
  cancelCall(callId) {
    return jsonInstance.post(`/demo-call/cancel/${callId}`);
  }
  getCallHistory(customerMobile) {
    return jsonInstance.get(`/demo-call/history/${customerMobile}`);
  }
  getClientOptions() {
    return jsonInstance.get("/client-calls/client-options");
  }
   getProductOptions() {
    return jsonInstance.get("/client-calls/product-options");
  }
}

export default new DemoCallService();
